export default __webpack_public_path__ + "static/media/ic_zimbabwe.61fb92c1.svg";